function animateNumber($el) {
  if ($el.hasClass("animated")) {
    return;
  }

  $el.addClass("animated");

  $el
    .prop("Counter", 0)
    .stop()
    .animate(
      {
        Counter: $el.data("number"),
      },
      {
        duration: 2000,
        easing: "swing",
        step: function (now) {
          $el.find(".num span").html(Math.ceil(now));
        },
      }
    );
}

export default {
  init() {
    $(window).scroll(function () {
      let top = jQuery(this).scrollTop();

      if ($(".worldwide-in .effect").visible(true)) {
        $(".section-image").addClass("show");
      }
      if ($(".r-and-d-in .effect").visible(true)) {
        $(".section-image").addClass("show");
      }
    });

    this._counterSlide();

    loadImageBanner();

    function loadImageBanner() {
      if ($(window).width() < 900) {
        $(".right-bg-img .right-bg-img-item").each(function () {
          let img = $(this).data("mobile");
          $(this).css({ "background-image": "url(" + img + ")" });
        });
      }
    }

    $(window).resize(function () {
      loadImageBanner();
    });

    if (
      $(".top-section-bg .top-section-bg-item:nth-child(1)").data("show") == 1
    ) {
      $(".slider-btns-wrap").show();
    } else {
      $(".slider-btns-wrap").hide();
    }

    setInterval(function () {
      changeSlide();
    }, 6000);

    function changeSlide() {
      if ($(".slider-btns ul li:hover").length != 0) {
        return;
      }

      let index = getRandomInt(
        $(".top-section-bg-item:last-child").data("index")
      );
      removeClasses();
      if (index == 0) {
        index = 1;
      }

      if (
        $(".top-section-bg .top-section-bg-item:nth-child(" + index + ")").data(
          "show"
        ) == 1
      ) {
        $(".slider-btns-wrap").show();
      } else {
        $(".slider-btns-wrap").hide();
      }

      $(".top-section-bg .top-section-bg-item").each(function () {
        if ($(this).data("index") == index) {
          $(this).addClass("active");
        }
      });

      $(".right-bg-img .right-bg-img-item").each(function () {
        if ($(this).data("index") == index) {
          $(this).addClass("active");
        }
      });

      $(".slider-btns ul li").each(function () {
        if ($(this).data("index") == index) {
          $(this).addClass("active");
        }
      });
    }

    function getRandomInt(max) {
      let indexNumber = $(".top-section-bg-item.active").next().data("index");

      if ($(".top-section-bg-item.active").data("index") == max) {
        return 1;
      }
      return indexNumber;
    }

    function removeClasses() {
      $(".slider-btns ul li").removeClass("active");
      $(".right-bg-img .right-bg-img-item").removeClass("active");
      $(".top-section-bg .top-section-bg-item").removeClass("active");
    }
    $(".slider-btns ul li").hover(function () {
      let indexNumber = $(this).data("index");

      removeClasses();

      let itemNumber;

      $(".right-bg-img .right-bg-img-item").each(function () {
        itemNumber = $(this).data("index");
        if (itemNumber == indexNumber) {
          $(this).addClass("active");
        }
      });

      $(".top-section-bg .top-section-bg-item").each(function () {
        itemNumber = $(this).data("index");
        if (itemNumber == indexNumber) {
          $(this).addClass("active");
        }
      });

      $(this).addClass("active");
    });
  },

  _counterSlide() {
    $(window).scroll(() => {
      if ($(".home-numbers").visible(true)) {
        $(".home-numbers-in ul li").each(function () {
          animateNumber($(this));
        });
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js